import { LogsButton } from "@/components/Button";
import TitleHeader from "@/components/TitleHeader";
import { Flex, Text, Image, useDisclosure } from "@chakra-ui/react";
import SelectAvatar from "../org/SelectAvatar";
import { avatarImg } from "@/utils/avatars";
import { useUserInfo } from "@/context/UserInfo";
import { useState } from "react";
import EditIcon from "./assets/edit.png";
import usePublicClient from "@/hooks/usePublicClient";
import { useNavigate } from "react-router-dom";
import { updateAvatar } from "@/api/login";

const SetOrgName = () => {
  const { avatarIndex, handleSetAvatarIndex } = useUserInfo();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentAvatarIndex, setCurrentAvatarIndex] = useState(avatarIndex);
  const [loading, setLoading] = useState(false);
  const publicClient = usePublicClient();
  const navigate = useNavigate();

  const handleOnAvatarChange = (index: number) => {
    setCurrentAvatarIndex(index);
    onClose();
  };

  const handleConfirmAvatar = async (avatarIndex: number) => {
    setLoading(true);
    try {
      await updateAvatar(avatarIndex);
      handleSetAvatarIndex(avatarIndex);
      navigate("/myInfo");
    } catch (error) {
      console.error("发送失败:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex
      flexDir={"column"}
      align={"center"}
      sx={{ padding: "20px", position: "relative", height: "100%" }}
    >
      <TitleHeader
        title="Edit Avatar"
        onBack={() => {
          navigate("/myInfo");
        }}
        color="#D8762B"
      ></TitleHeader>
      <Flex
        sx={{
          width: "100px",
          height: "100px",
          background: "#fff",
          borderRadius: "50%",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          fontSize: "72px",
          marginTop: "auto",
          position: "relative",
        }}
        align={"center"}
        justify={"center"}
      >
        {avatarImg(currentAvatarIndex)}
        <Image
          src={EditIcon}
          sx={{
            width: "30px",
            height: "30px",
            position: "absolute",
            bottom: "0px",
            right: "0px",
          }}
          onClick={onOpen}
        ></Image>
      </Flex>
      <LogsButton
        onClick={() => {
          handleConfirmAvatar(currentAvatarIndex);
        }}
        loading={loading}
        sx={{
          marginTop: "auto",
        }}
      >
        Confirm
      </LogsButton>
      <SelectAvatar
        isOpen={isOpen}
        onClose={onClose}
        handleOnAvatarChange={handleOnAvatarChange}
      />
    </Flex>
  );
};

export default SetOrgName;
